// extracted by mini-css-extract-plugin
export default {"Box":"MarkdownViewer-module__Box--JAVzj"};